import request from "./request";
const API_PREFIX = "/mp/user";

/**
 * 获取用户信息
 */
export function getUserInfo(params = {}) {
  return request({
    url: `${API_PREFIX}/getUserInfo`,
    method: "get",
    params,
  });
}

/**
 * 设置用户终端信息（GET，参数走 query，如 ?url=）
 */
export function setTerminalInfo(params = {}) {
  return request({
    url: `${API_PREFIX}/setStorage`,
    method: "get",
    params,
  });
}

/**
 * 退款
 */
export function applyRefund(data) {
  return request({
    url: `${API_PREFIX}/applyRefund`,
    method: "post",
    data,
  });
}

/**
 * 获取余额流水列表
 */
export function getBalanceFlowList(data) {
  return request({
    url: `${API_PREFIX}/getBalanceFlowPage`,
    method: "post",
    data,
  });
}

/**
 * 上报问题 / 意见反馈
 * @param {Object} data
 * @param {string} data.problemType - 问题类型："1" 柜子故障 "2" 支付 "3" 订单 "4" 其他
 * @param {string} data.description - 问题描述
 * @param {string} [data.orderNo] - 关联订单号
 * @param {string} [data.contactInfo] - 联系方式
 * @param {string[]} [data.imageUrls] - 图片地址列表（可先传 data URL，若后端仅接受 HTTP 需先走上传换 URL）
 */
export function addFeedback(data) {
  return request({
    url: `${API_PREFIX}/addFeedback`,
    method: "post",
    data,
  });
}

/**
 * 申请快速提现（原 withdrawal，余额/押金等入参不变：amount、withdrawFundType 等）
 */
export function applyWithdrawalFast(data) {
  return request({
    url: `${API_PREFIX}/applyFast`,
    method: "post",
    data,
  });
}
